import { useReferralsContext } from '@user/components/Referrals/context'
import { useCallback } from 'react'
import { Props as DrawerProps } from '../UpdateReferralDrawer'
import { referralDataMapperModelToDTO } from '@user/components/Referrals/components/UpdateReferral/UpdateReferralDrawer/hooks/utils'

type Props = Pick<DrawerProps, 'onClose' | 'onSave' | 'required'>

export function useHandlers(props: Props) {
  const { onClose, onSave } = props

  const [{ ...referralModel }] = useReferralsContext()

  const handleCancel = useCallback(() => {
    onClose()
  }, [onClose])

  const handleSave = useCallback(() => {
    onSave(referralDataMapperModelToDTO(referralModel))
  }, [onSave, referralModel])

  return { handleCancel, handleSave } as const
}
